module.exports = __webpack_public_path__ + "static/021_Gippsland-82f05ffac8dfe8a3fe4427bbfc765824.jpg";